export function randomLong(): number {
  const c = (globalThis as { crypto?: Crypto }).crypto;
  if (c && typeof c.getRandomValues === 'function') {
    const buf = new Uint32Array(1);
    c.getRandomValues(buf);
    return buf[0] & 0x7fffffff;
  }
  return Math.floor(Math.random() * 2147483648);
}
